import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TaxctcService } from '../../../../_services/taxctc/taxctc.service';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';

@Component({
  selector: 'app-interns-stipend-form',
  templateUrl: './interns-stipend-form.component.html',
  styleUrls: ['./interns-stipend-form.component.scss']
})
export class InternsStipendFormComponent implements OnInit {
  internsStipendform 
  rowData: any;
  form: FormGroup;
  tenantId: string;
  currentUser: any;
  selectedCheckboxData = []
  deleteConfirmationMsg = 'Are you sure you want to delete'
  internsStipendId: any;
  getUserName: any;
  userDropdownList = [];
  taxregimDropdownList = [];
  tdsIgnoreMonthsArray : any[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

  constructor(
    private formBuilder: FormBuilder,
    private storageService: LocalStorageService, 
    private allocationService: AllocationService,
    private router: Router,
    private route: ActivatedRoute,
    private taxctcService :TaxctcService
  ) { 
    this.internsStipendform = this.formBuilder.group({
    employeeId: new FormControl(''),
    financialYear: new FormControl(''),
    ctc: new FormControl(''),
    startMonth: new FormControl(''),
    endMonth: new FormControl(''),
    componentName: new FormControl(''),
    componentValue: new FormControl(''),
    miscellaneous: new FormControl(''),
    deduction: new FormControl(''),
    taxRegimeNo: new FormControl(''),
    employeeName: new FormControl(''),
    tdsIgnoreMonths: new FormControl(''),
    tdsIgnoreMonthsValues: new FormControl(''),
    absolute: new FormControl(''),
    type: new FormControl('')
  })
}

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.internsStipendform.value.componentName = "Stipend";
    this.internsStipendform.patchValue(this.internsStipendform.value);
    this.internsStipendId = this.route.snapshot.paramMap.get('id');
    if (this.internsStipendId) this.getUserInternsStipendById(this.internsStipendId)
    this.getUserList();
  }

  getUserList() {
    this.userDropdownList = [];
    this.allocationService.getUserDetails().subscribe((response) => {
      this.getUserName = response;
      for (let item of response) {
        this.userDropdownList.push(
          `${item.id} . ${item.firstName} ${item.lastName}`
        );
      }
    });
  }

  getUserInternsStipendById(id){
    this.taxctcService.getuserCtcsById(id).subscribe((response) => {
      if(response) {
        this.internsStipendform.patchValue(response);
        const array = response.tdsIgnoreMonths?.split(',');
        this.internsStipendform.value.tdsIgnoreMonths = array;
        this.internsStipendform.value.employeeId = this.internsStipendform.value.employeeId + " . " + this.internsStipendform.value.employeeName;
        this.internsStipendform.patchValue(this.internsStipendform.value);
      }
    }, (error) =>{
      
    });
  }

  createUserInternsStipend() {
    let tdsIgnoredMonth = this.internsStipendform.get('tdsIgnoreMonths').value?.toString();
    let details = {
      employeeId: this.internsStipendform.get('employeeId') ? this.internsStipendform.get('employeeId').value.split(' . ')[0] : null,
      employeeName: this.internsStipendform.get('employeeId') ? this.internsStipendform.get('employeeId').value.split(' . ')[1] : null,
      financialYear: this.internsStipendform.get('financialYear').value,
      ctc: this.internsStipendform.get('ctc').value,
      startMonth: this.internsStipendform.get('startMonth').value,
      endMonth: this.internsStipendform.get('endMonth').value,
      componentName: this.internsStipendform.get('componentName').value,
      componentValue: this.internsStipendform.get('componentValue').value,
      miscellaneous: this.internsStipendform.get('miscellaneous').value,
      deduction: this.internsStipendform.get('deduction').value,
      taxRegimeNo: this.internsStipendform.get('taxRegimeNo').value,
      tdsIgnoreMonths: tdsIgnoredMonth,
      tdsIgnoreMonthsValues: this.internsStipendform.get('tdsIgnoreMonthsValues').value,
      absolute: this.internsStipendform.get('absolute').value,
      type: "stipend"
    }
    this.taxctcService.createuserCtcs(details).subscribe((response: any) => {
      // update grid after creating new contact & close the modal
      this.backToInternsStipendList();
    });
  }

  backToInternsStipendList() {
    this.router.navigate([this.tenantId + '/dashboard/finance/interns-stipend']);
  }

  updateUserInternsStipend() {
    let tdsIgnoredMonth = this.internsStipendform.get('tdsIgnoreMonths').value?.toString();
    let details = {
      //id: this.taxmetadataform.get('id').value,
      employeeId: this.internsStipendform.get('employeeId') ? this.internsStipendform.get('employeeId').value.split(' . ')[0] : null,
      employeeName:this.internsStipendform.get('employeeId') ? this.internsStipendform.get('employeeId').value.split(' . ')[1] : null,
      financialYear: this.internsStipendform.get('financialYear').value,
      ctc: this.internsStipendform.get('ctc').value,
      startMonth: this.internsStipendform.get('startMonth').value,
      endMonth: this.internsStipendform.get('endMonth').value,
      componentName: this.internsStipendform.get('componentName').value,
      componentValue: this.internsStipendform.get('componentValue').value,
      miscellaneous: this.internsStipendform.get('miscellaneous').value,
      deduction: this.internsStipendform.get('deduction').value,
      taxRegimeNo: this.internsStipendform.get('taxRegimeNo').value,
      tdsIgnoreMonths: tdsIgnoredMonth,
      tdsIgnoreMonthsValues: this.internsStipendform.get('tdsIgnoreMonthsValues').value,
      absolute: this.internsStipendform.get('absolute').value,
      type: "stipend"
    }
    // console.log("details", details)
    this.taxctcService.updateuserCtcs(details, this.internsStipendId).subscribe(res => {
      this.selectedCheckboxData = [];
      this.backToInternsStipendList();
    });
  }

}